import type {
	ExtractInjectionAPI,
	PMPlugin,
	PMPluginFactoryParams,
} from '@atlaskit/editor-common/types';

import type { AIPlugin } from '../../aiPluginType';
import type { AIGlobalOptIn, EditorPluginAIProvider } from '../../types/types';
import { improveWriting } from '../../ui/prebuilt/config-items/prompts/enhance/enhance';
import { createAiQuickPromptKeymapPlugin } from './ai-quick-prompt-plugin-keymap';
import { createAiQuickPromptPlugin } from './ai-quick-prompt-plugin-main';
import { StandDownManager } from './stand-down-manager';

export function createAiQuickPromptPlugins({
	aiGlobalOptIn,
	api,
	product,
}: {
	aiGlobalOptIn: AIGlobalOptIn;
	api: ExtractInjectionAPI<AIPlugin> | undefined;
	product: EditorPluginAIProvider['product'];
}): PMPlugin[] {
	const configItem = improveWriting();
	const standDownManager = new StandDownManager({ api });

	return [
		{
			name: 'ai-quick-prompt',
			plugin: ({ dispatch, getIntl }: PMPluginFactoryParams) =>
				createAiQuickPromptPlugin({
					api,
					configItem,
					dispatch,
					getIntl,
					product,
					standDownManager,
				}),
		},
		{
			name: 'ai-quick-prompt-keymap',
			plugin: () =>
				createAiQuickPromptKeymapPlugin({
					aiGlobalOptIn,
					api,
					configItem,
					standDownManager,
				}),
		},
	];
}
